export default function PHP_use_result() {
  return (
    <div>
      <h1>PHP_use_result</h1>
    </div>
  );
}
